module.exports = __webpack_public_path__ + "static/media/reactClientLogo.69494d35.png";